import React from "react";
import {DocumentTopic, DocumentTopicRestControllerApiFactory} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import {Grid} from "@mui/material";


export const DocumentTopicEditPage = () => {
    const apiManager = useApiManager();
    const ctrl = apiManager.factory(DocumentTopicRestControllerApiFactory);

    const form = useForm({
        fetcher: (id) => ctrl.getDocumentTopic(id),
        updater: (bean) => ctrl.saveDocumentTopic(bean),
        remover: (id) => ctrl.deleteOrDismissDocumentTopic(id),
        factory: () => {
            return {} as DocumentTopic;
        },
    } as UseFormProps<DocumentTopic>);

    return (
        <>
            <FormContent form={form} title={"Tema de documentos"}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={9}>
                        <FormInput type={"text"} field={"name"} label={"Nombre"}/>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormInput type={"number"} field={"position"} label={"Orden"}
                                   helperText={"En el portal, de menor a mayor"}/>
                    </Grid>
                </Grid>

                <FormInput type={"text"} field={"description"} label={"Descripción"} rows={4}/>
            </FormContent>
        </>
    );
};
